import LoginService from '@/service/LoginService';
import Functions from "@/functions";

class UserData {
  constructor() {
    this.idpUserId = null;
    this.country = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.phone = null;
    this.address = null;
    this.city = null;
    this.postalCode = null;
    this.language = null;
    this.preferences = {
      "push_notification": true,
      "offline_mail_notification": true,
      "measurement_system": "metric",
      "hours_display_system": "24h",
      "appliance_report": true,
      "haccp_report": true,
      "alarm_mail_notification": true
    }
    this.role = null;
    this.pro = false;
    this.rememberMe = false;
    this.tokens = {
      personal: null,
      refresh: null,
      generic: null
    };
    this.cycleLibrary = false;
    this.energyPanel = false;
    this.chatbot = false;
    this.digitalWarehouse = false;
  }
}

// initial state
const state = () => (new UserData());

const loginService = new LoginService();

// getters
const getters = {
  email: state => {
    return state.email
  },
  role: state => {
    return state.role ?? "";
  },
  cycleLibrary: state => {
    return state.cycleLibrary
  },
  energyPanel: state => {
    return state.energyPanel
  },
  generictoken: state => {
    return state.tokens.generic;
  },
  personaltoken: state => {
    return state.tokens.personal;
  },
  refreshtoken: state => {
    return state.tokens.refresh;
  },
  unit: state => {
    let ms = state.preferences["measurement_system"];
    return ms && ms=='imperial' ? '°F': '°C';
  },
  isCelsius: state => {
    let ms = state.preferences["measurement_system"];
    return !(ms && ms=='imperial')
  },
  is24hour: state => {
    let hds = state.preferences["hours_display_system"];
    if(!hds || hds=='12h')
      return false;
    return true;
  },
  chatbot: state => {
    return state.chatbot;
  },
  digitalWarehouse: state => {
    return state.digitalWarehouse;
  }

}

// actions
const actions = {
  init: async ({ commit, dispatch, state }) => {
    console.log(state);
    commit('initUserdata');
    // dispatch("genericLogin");
    // dispatch("personalRefresh");

    setInterval(function() {
      // dispatch("genericLogin");
      dispatch("personalRefresh");
    },(50*60*1000));

  },
  personalRefresh: async ({ commit, state }) => {
    let refreshToken = state.tokens.refresh;
    if(refreshToken) {
      await loginService.refresh(refreshToken).then((data) => {
        console.log("Personal Token refreshed");
        commit('personalRefreshData', { 
          personal: data.access_token,
          refresh: data.refresh_token
        });
      }).catch(error => {
        if( error.response ){
          console.log(error.response.data); // => the response payload 
        } else {
          console.log(JSON.stringify(error));
        }
        commit('logout');
      });
    } else {
      commit('logout');
    }
  },
  genericLogin: async ({ commit }) => {
    loginService.generic().then((data) => {
      console.log("Generic Token refreshed");
      commit('genericLoginData', { 
        generic: data.access_token
      });
    }).catch(error => {
      if( error.response ){
        console.log(error.response.data); // => the response payload 
      } else {
        console.log(JSON.stringify(error));
      }
    });
  },
}

// mutations
const mutations = {
  initUserdata: function(state) {
    state.tokens.generic = null;
    if (state.email) {
      console.log("SESSION ALREADY INITIALIZED");
      console.log("Remember me: "+state.rememberMe);
      console.log("Session active: "+sessionStorage.getItem("sessionActive"));
      if(!state.rememberMe && !sessionStorage.getItem("sessionActive")) {
        console.log("Sloggo perché non c'è il remember me");
        initState(state);
      }
    } else {
      console.log("SESSION INIT EMPTY");
      initState(state);
    }
  },
  logout: function(state) {
    console.log("LOGOUT");
    sessionStorage.setItem("sessionActive",false);
    initState(state, {
      email: state.email
    });
  },
  genericLoginData: function(state, payload) {
    state.tokens.generic = payload.generic;
  },
  personalLoginData: function(state, payload) {
    initUserProfile(state, payload);
    state.tokens.personal = payload.personal;
    state.tokens.refresh = payload.refresh;
    state.rememberMe = payload.rememberMe;
    sessionStorage.setItem("sessionActive",true);
  },
  updateUserinfo: function(state, payload) {
    initUserProfile(state, payload);
  },
  personalRefreshData: function(state, payload) {
    state.tokens.personal = payload.personal;
    state.tokens.refresh = payload.refresh;
  },
  role(state, payload) {
    state.role = payload;
  },
}

function initUserProfile(state, userprofile) {
  if(!userprofile) {
    userprofile = {};
  }
  if(!userprofile.preferences) {
    userprofile.preferences = {};
  }
  if(userprofile.personal) {
    let uid = Functions.parseJwt(userprofile.personal).oid;
    state.idpUserId = uid;
  }
  state.country = userprofile.country;
  state.firstName = userprofile.firstName;
  state.lastName = userprofile.lastName;
  state.email = userprofile.email;
  state.phone = userprofile.phone;
  state.address = userprofile.address;
  state.city = userprofile.city;
  state.postalCode = userprofile.postalCode;
  state.language = userprofile.language;
  state.preferences = {
    "push_notification": userprofile.preferences["push_notification"],
    "offline_mail_notification": userprofile.preferences["offline_mail_notification"],
    "measurement_system": userprofile.preferences["measurement_system"],
    "hours_display_system": userprofile.preferences["hours_display_system"],
    "appliance_report": userprofile.preferences["appliance_report"],
    "haccp_report": userprofile.preferences["haccp_report"],
    "alarm_mail_notification": userprofile.preferences["alarm_mail_notification"]
  }
  state.role = userprofile.role;
  state.pro = userprofile.pro;
  state.cycleLibrary = userprofile.cycleLibrary;
  state.energyPanel = userprofile.energyPanel;
  state.chatbot = userprofile.chatbot;
  state.digitalWarehouse = userprofile.digitalWarehouse;
}

function initState(state, userprofile) {
  initUserProfile(state, userprofile);
  state.idpUserId = null;
  state.tokens = {
    personal: null,
    refresh: null,
    generic: null
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}